import React from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';

type Props = {
	height: number;
};

export default function Control(props: Props) {
	return (
		<LoadingWrapper height={props.height}>
			<Spinner size="medium" />
		</LoadingWrapper>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingWrapper = styled.div<{ height: string | number }>({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ height }) => `${height}px`,
});
